"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRedirectSignOutUrl = exports.resolveRedirectSignInUrl = void 0;
const internals_1 = require("aws-amplify/adapter-core/internals");
const resolveRedirectSignInUrl = (origin, oAuthConfig) => {
    const redirectUrl = oAuthConfig.redirectSignIn.find(url => url.startsWith(origin));
    if (!redirectUrl) {
        throw createError('redirectSignIn');
    }
    return redirectUrl;
};
exports.resolveRedirectSignInUrl = resolveRedirectSignInUrl;
const resolveRedirectSignOutUrl = (origin, oAuthConfig) => {
    const redirectUrl = oAuthConfig.redirectSignOut.find(url => url.startsWith(origin));
    if (!redirectUrl) {
        throw createError('redirectSignOut');
    }
    return redirectUrl;
};
exports.resolveRedirectSignOutUrl = resolveRedirectSignOutUrl;
const createError = (urlType) => new internals_1.AmplifyServerContextError({
    message: `No valid ${urlType} url found in the OAuth config.`,
    recoverySuggestion: `Check the OAuth config and ensure the ${urlType} url is valid.`,
});
